import config from "flow/config";
import { Dictionary } from "./api/types";
import MyFlow from "./MyFlow";

const clientLogLevels: Dictionary<number> = {};

let sysLogUrl: string;
const logLevels = {
    none: -1,
    emergency: 0,
    alert: 1,
    critical: 2,
    error: 3,
    warning: 4,
    notice: 5,
    information: 6,
    debug: 7
};

async function reportToServer(myFlow: MyFlow, message: string, content: Dictionary | string, logLevel: number) {
    const currentModuleLogLevel = clientLogLevels[myFlow.manifest.moduleId];

    if (
        currentModuleLogLevel === undefined ||
        currentModuleLogLevel === logLevels.none ||
        currentModuleLogLevel < logLevel
    ) {
        return;
    }

    try {
        const clientMessage = {
            source: "",
            message: message,
            content: typeof content === "string" ? content : JSON.stringify(content),
            logType: logLevel,
            moduleId: myFlow.manifest.moduleId,
            moduleKeyName: myFlow.manifest.moduleKeyName
        };

        //make an ajax call to web api to log into syslog
        await myFlow.postJSON(sysLogUrl, JSON.stringify(clientMessage), true);
    } catch (e) {
        // Don't go through the framework logger. We don't want a loop where we try to syslog failing syslog calls.
        if (e instanceof TypeError) {
            // Type error hence stringify.
            console.warn("Couldn't stringify message. Nothing sent to server.");
        } else {
            console.error("Failed to log to syslog.", e);
        }
    }
}

function setSysLogUrl(baseUrl: string) {
    sysLogUrl = baseUrl + config.writeLogUrl;
}

function addClientLogLevels(moduleId: string, logLevel: number) {
    clientLogLevels[moduleId] = logLevel;
}

export default {
    reportToServer: reportToServer,
    setSysLogUrl: setSysLogUrl,
    addClientLogLevels: addClientLogLevels,
    logLevels: logLevels
};
